/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DosageDilution from './dosage-dilution';
import DosageDilutionDetail from './dosage-dilution-detail';
import DosageDilutionUpdate from './dosage-dilution-update';
import DosageDilutionDeleteDialog from './dosage-dilution-delete-dialog';

const DosageDilutionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DosageDilution />} />
    <Route path="new" element={<DosageDilutionUpdate />} />
    <Route path=":id">
      <Route index element={<DosageDilutionDetail />} />
      <Route path="edit" element={<DosageDilutionUpdate />} />
      <Route path="delete" element={<DosageDilutionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DosageDilutionRoutes;
